<template>
    <Modal :mask-closable="false" v-model="show" title="当前登录账号重置密码"  :width="500">
        <table class="QHtable"  v-if="show">
            <tr>
                <td width="90px"><b>原来密码</b></td>
                <td><Input v-model="form.oldpassword" placeholder="请输入原来密码" type="password" /></td>
            </tr>
            <tr>
                <td><b>新的密码</b></td>
                <td><Input v-model="form.password" placeholder="请输入新的密码" type="password" /></td>
            </tr>
            <tr>
                <td><b>确认密码</b></td>
                <td><Input v-model="form.repassword" placeholder="确认密码和新的密码保持一致" type="password" /></td>
            </tr>
        </table>
        <div slot="footer">
            <Button @click="clearFrom">取消</Button>
            <Button type="primary" @click="saveOk" :loading="loading">确定</Button>
        </div>
    </Modal>
</template>

<script>
import data from "./updatePasswordData.js"
export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            loading: false,
            show: false,
            form: { ...data.data }
        }
    },
    methods: {
        // +----------------------------------------------------------------------
        // | Desc:唤起修改
        // +----------------------------------------------------------------------
        hiUpdete() {
            this.clearFrom();
            this.show = true;
        },

        // +----------------------------------------------------------------------
        // | Desc:确认提交
        // +----------------------------------------------------------------------
        saveOk() {
            //综合赋值验证
            var parameter = this.$isSubmitValidGetPram(this, data);
            if (!parameter) {
                return;
            };
            var parameterFmt = {
                password: parameter.oldpassword,
                newPassword: parameter.password
            };
            //参数整合与接口
            var that = this;
            var https = {
                isLoading: 'isLoadingStr',
                api: this.$api.rePassword,
                parameter: parameterFmt,
                successMsg: "保存成功"
            };
            this.$httpsApi(https, function (res) {
                that.clearFrom();
                that.$emit('success');
            });
        },

        // +----------------------------------------------------------------------
        // | Desc:清理表单
        // +----------------------------------------------------------------------
        clearFrom() {
            this.loading = false;
            this.show = false;
            this.form = { ...data.data };
        }
    }
};
</script>